/**
 * What state is this game in, as the UI needs it.
 *
 * Three surfaces show a game (the schedule card, the Home hero, the game
 * page) and each one asks the same four questions of it. Asking them in one
 * place means a card, a hero and a page header can never disagree about
 * whether a game has kicked off.
 *
 * Pure, no React: `status` can be overridden by whatever the caller knows
 * better, which is how the practice game stays "scheduled" until the viewer
 * starts it and how the game page uses its live engine state.
 */

import { GAME_STATUS, isOffSchedule } from "./gameEngine";

export function readGameStatus(game, statusOverride) {
  const status = statusOverride ?? game?.status ?? GAME_STATUS.SCHEDULED;

  const live = status === GAME_STATUS.IN_PROGRESS;
  const final = status === GAME_STATUS.FINAL;

  /**
   * Postponed, called off, stopped, delayed, or a status we could not read.
   * For all of these, both of the things a card normally shows are wrong: a
   * kickoff time the game is not keeping, and a scoreline that is missing or
   * half-played. So it shows neither.
   */
  const offSchedule = isOffSchedule(status);

  return {
    status,
    live,
    final,
    offSchedule,
    /** A scoreline is only meaningful once there is one. */
    showScore: live || final,
  };
}
